/// <reference types="./shared.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $copilot_message from "../../../../common/data/copilot_message.mjs";
import { CopilotMessage } from "../../../../common/data/copilot_message.mjs";
import * as $month from "../../../../common_common/gleam/time/calendar/month.mjs";
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $keyboard from "../../../../ds/ds/components/keyboard.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $calendar from "../../../../gleam_time/gleam/time/calendar.mjs";
import * as $duration from "../../../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import { State } from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $copilot from "../../../data/ui/copilot.mjs";
import * as $s from "../../../frontend/view/styles/copilot.mjs";
import * as $dropdown_styles from "../../../frontend/view/styles/dropdowns.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../../../gleam.mjs";

const FILEPATH = "src/frontend/view/copilot/shared.gleam";

export class Props extends $CustomType {
  constructor(is_loading, id, thread, input_disabled) {
    super();
    this.is_loading = is_loading;
    this.id = id;
    this.thread = thread;
    this.input_disabled = input_disabled;
  }
}

export function props(model, id) {
  let $ = $bright.state(model);
  let state = $;
  let loading = $.loading;
  let is_loading = loading.copilot_questions || loading.organization_tags;
  let thread = $list.key_find(state.copilot.threads, id);
  let thread$1 = $option.from_result(thread);
  let input_disabled = $copilot.is_input_disabled(thread$1);
  return new Props(is_loading, id, thread$1, input_disabled);
}

function history_skeleton() {
  return $s.history_column(
    toList([]),
    toList([
      $skeleton.skeleton(100, 20),
      $skeleton.full_width(20),
      $skeleton.full_width(20),
      $skeleton.full_width(20),
    ]),
  );
}

function keep_copilot_threads(thread) {
  let $ = thread[1].messages;
  if ($ instanceof $Empty) {
    return false;
  } else {
    let $1 = $.head;
    if ($1 instanceof CopilotMessage) {
      let $2 = $1.kind;
      if ($2 instanceof $copilot_message.Copilot) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}

function is_before(date, days) {
  let delta = $timestamp.difference(date, $timestamp.system_time());
  let _block;
  let _pipe = $duration.to_seconds(delta);
  _block = $float.round(_pipe);
  let delta_seconds = _block;
  let max_delta = days * 86_400;
  return delta_seconds < max_delta;
}

function group_threads_per_date(model) {
  let state = $bright.state(model);
  let _pipe = state.copilot.threads;
  let _pipe$1 = $list.filter(_pipe, keep_copilot_threads);
  let _pipe$2 = $list.group(
    _pipe$1,
    (thread) => {
      let $ = $list.first(thread[1].messages);
      if (!($ instanceof Ok)) {
        throw makeError(
          "let_assert",
          FILEPATH,
          "frontend/view/copilot/shared",
          119,
          "group_threads_per_date",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 3505,
            end: 3563,
            pattern_start: 3516,
            pattern_end: 3527
          }
        )
      }
      let message = $[0];
      let time = message.created_at;
      return $bool.guard(
        is_before(time, 1),
        "Today",
        () => {
          return $bool.guard(
            is_before(time, 8),
            "Previous 7 days",
            () => {
              return $bool.guard(
                is_before(time, 31),
                "Previous 30 days",
                () => {
                  let $1 = $timestamp.to_calendar(time, $calendar.utc_offset);
                  let date = $1[0];
                  let $2 = is_before(time, 365);
                  if ($2) {
                    return $month.to_string(date.month);
                  } else {
                    return $int.to_string(date.year);
                  }
                },
              );
            },
          );
        },
      );
    },
  );
  let _pipe$3 = $dict.map_values(
    _pipe$2,
    (_, threads) => {
      return $list.sort(
        threads,
        (a, b) => {
          let $ = $list.first(a[1].messages);
          if (!($ instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "frontend/view/copilot/shared",
              132,
              "group_threads_per_date",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 4088,
                end: 4135,
                pattern_start: 4099,
                pattern_end: 4104
              }
            )
          }
          let a$1 = $[0];
          let $1 = $list.first(b[1].messages);
          if (!($1 instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "frontend/view/copilot/shared",
              133,
              "group_threads_per_date",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $1,
                start: 4142,
                end: 4189,
                pattern_start: 4153,
                pattern_end: 4158
              }
            )
          }
          let b$1 = $1[0];
          return $timestamp.compare(b$1.created_at, a$1.created_at);
        },
      );
    },
  );
  return $dict.to_list(_pipe$3);
}

export function history(model, props) {
  return $bool.lazy_guard(
    props.is_loading,
    history_skeleton,
    () => {
      let threads = group_threads_per_date(model);
      return $s.history_column(
        toList([]),
        (() => {
          let skip = $list.is_empty(threads);
          let empty_history = toList([
            $s.history_day_title(toList([]), toList([$h.text("No history")])),
          ]);
          return $bool.guard(
            skip,
            empty_history,
            () => {
              return $list.map(
                threads,
                (_use0) => {
                  let when = _use0[0];
                  let threads$1 = _use0[1];
                  return $l.fragment(
                    listPrepend(
                      $s.history_day_title(toList([]), toList([$h.text(when)])),
                      $list.map(
                        threads$1,
                        (thread) => {
                          let thread_id = thread[0];
                          let thread$1 = thread[1];
                          return $s.history_question(
                            toList([$a.href("/co-pilot/" + thread_id)]),
                            toList([$h.text(thread$1.title)]),
                          );
                        },
                      ),
                    ),
                  );
                },
              );
            },
          );
        })(),
      );
    },
  );
}

function stop_propagation() {
  let _pipe = $e.on("click", $decode.failure($unsafe.coerce(""), ""));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

function input_tags(model) {
  let state = $bright.state(model);
  let on_click = (var0) => { return new $msg.UserSelectedCopilotTag(var0); };
  let placeholder = $dropdown.placeholder("Select tags");
  let panel = $dropdown.panel_class($dropdown_styles.spacing());
  return $l.row(
    toList([$l.gap(9), $l.align("center")]),
    toList([stop_propagation()]),
    toList([
      $dropdown.dropdown(
        on_click,
        toList([placeholder, panel]),
        $list.filter_map(
          state.organization.tags,
          (tag) => {
            let $ = $list.contains(state.copilot.tags, tag.id);
            if ($) {
              return new Error(undefined);
            } else {
              let _pipe = $dropdown.choice(tag.name, tag.id);
              let _pipe$1 = $dropdown.with_class(
                _pipe,
                $dropdown_styles.neutral(),
              );
              return new Ok(_pipe$1);
            }
          },
        ),
      ),
      $l.row(
        toList([$l.gap(6), $l.align("center")]),
        toList([]),
        $list.map(
          state.copilot.tags,
          (tag) => {
            let $ = $list.find(
              state.organization.tags,
              (t) => { return t.id === tag; },
            );
            if ($ instanceof Ok) {
              let tag$1 = $[0];
              return $label.label(
                toList([
                  $label.medium(),
                  $label.content(tag$1.name),
                  $label.icon($icons.tiny($icons.cross())),
                  $label.icon_right(),
                  $label.on_click(new $msg.UserDeletedCopilotTag(tag$1.id)),
                ]),
              );
            } else {
              return $el.none();
            }
          },
        ),
      ),
    ]),
  );
}

export function copilot_input(model, props) {
  let state = $bright.state(model);
  return $s.ai_search_form(
    toList([
      $e.on_submit((_) => { return new $msg.UserSubmittedCopilotInput(); }),
    ]),
    toList([
      $s.ai_search_pro_tip(
        toList([]),
        toList([
          $el.text("Pro tip, use "),
          $keyboard.kbd_button("Enter"),
          $el.text(" to send your message directly!"),
        ]),
      ),
      $input.input(
        toList([
          $input.multiline(),
          $input.icon($icons.paper_plane()),
          $input.on_input(
            (var0) => { return new $msg.UserEdittedCopilotInput(var0); },
          ),
          $input.on_submit(new $msg.UserSubmittedCopilotInput()),
          $input.value(state.copilot.input),
          $input.disabled(props.input_disabled),
          $input.enter_submit(),
          $input.placeholder(
            (() => {
              let $ = props.input_disabled;
              if ($) {
                return "Create a new conversation to ask Steerlab a question.";
              } else {
                return "Ask steerlab a question…";
              }
            })(),
          ),
        ]),
      ),
      $html.div(
        $css.class$(toList([$css.padding_top($length.px(8))])),
        toList([]),
        toList([]),
      ),
      input_tags(model),
      $s.ai_search_disclaimer(
        toList([]),
        toList([$el.text("Make sure to verify AI generated answers.")]),
      ),
    ]),
  );
}

export function loading_answer() {
  return $s.loading_indicator(
    toList([]),
    toList([
      $l.column(
        toList([$l.gap(6)]),
        toList([]),
        toList([
          $skeleton.skeleton(200, 12),
          $skeleton.skeleton(150, 12),
          $skeleton.skeleton(175, 12),
        ]),
      ),
    ]),
  );
}

export function show_loading_answer(show) {
  return $bool.lazy_guard(!show, $el.none, () => { return loading_answer(); });
}

export function tool_bubble(is_last) {
  return $l.fragment(
    toList([
      show_loading_answer(is_last),
      $l.column(
        toList([$l.align("start")]),
        toList([]),
        toList([
          $s.tool_callout(
            is_last,
            toList([]),
            toList([
              $icons.tiny($icons.info()),
              $el.text(
                (() => {
                  if (is_last) {
                    return "Steerlab is searching for an answer in your Content Library. Please wait a few seconds…";
                  } else {
                    return "Steerlab searched for an answer in your Content Library.";
                  }
                })(),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}
